// 配置管理工具

/**
 * 根据当前页面主机推断后端API基础地址
 * 在所有环境中都使用相对路径（空字符串）
 * 这样可以通过代理转发避免跨域问题
 * @returns {string} API基础URL
 */
export const inferApiBaseUrl = () => {
  try {
    // 如果已经设置了环境变量，直接使用
    if (process.env.REACT_APP_API_BASE_URL !== undefined) {
      return process.env.REACT_APP_API_BASE_URL;
    }

    // 在所有环境中都使用相对路径
    // 这样可以通过代理转发避免跨域问题
    return '';
  } catch (_) {
    // 出错时返回空字符串，使用相对路径通过代理
    return '';
  }
};

/**
 * API基础URL，从环境变量读取
 * 在开发环境中使用相对路径，通过setupProxy.js代理转发
 * 在生产环境中，如果使用nginx反向代理，也使用相对路径
 */
export const API_BASE_URL = inferApiBaseUrl();

/**
 * API版本前缀
 */
export const API_PREFIX = '/api/v1';

export const ENABLE_MOCK_INTERVIEW_EVALUATION = process.env.REACT_APP_ENABLE_MOCK_INTERVIEW_EVALUATION !== 'true';
